// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"c23cf016","787":"91d75eb2"}[chunkId] + ".chunk.js";
};